function getDeviceInfo() {
  const ua = navigator.userAgent || navigator.vendor || window.opera

  let deviceType = 'Desktop'
  if (/android/i.test(ua)) {
    deviceType = 'Mobile (Android)'
  } else if (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) {
    deviceType = 'Mobile (iOS)'
  } else if (/mobile/i.test(ua)) {
    deviceType = 'Mobile'
  }

  // Device "name" is not directly available; we can only infer from UA string
  let deviceName = 'Unknown Device'
  if (/iPhone/i.test(ua)) {
    deviceName = 'iPhone'
  } else if (/iPad/i.test(ua)) {
    deviceName = 'iPad'
  } else if (/Android/i.test(ua)) {
    const match = ua.match(/Android.*;\s([^)]+)\)/)
    deviceName = match && match[1] ? match[1].trim() : 'Android Device'
  } else if (/Windows NT/i.test(ua)) {
    deviceName = 'Windows PC'
  } else if (/Macintosh/i.test(ua)) {
    deviceName = 'Mac'
  } else if (/Linux/i.test(ua)) {
    deviceName = 'Linux PC'
  }

  return {
    deviceName,
    deviceType
  }
}

function getBannerPlayerRegCookies() {
  const prefix = 'banner-player-reg-'
  const cookies = document.cookie.split('; ')
  const values = []
  for (const c of cookies) {
    const [name, ...rest] = c.split('=')
    if (name.startsWith(prefix)) {
      values.push(rest.join('='))
    }
  }
  return values
}

function getXDirectBannerCookies() {
  const prefix = 'x-direct-banner-id-'
  const cookies = document.cookie.split('; ')
  const values = []
  for (const c of cookies) {
    const [name, ...rest] = c.split('=')
    if (name.startsWith(prefix)) {
      values.push(rest.join('='))
    }
  }
  const xBannerIds = values?.map(item => {
    return {
      id: item.split('|')[0],
      record_created_at: item.split('|')[1]
    }
  })
  return xBannerIds
}

function customSetCookie(name, value, days) {
  let expires = ''
  if (days) {
    const date = new Date()
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000)
    expires = '; expires=' + date.toUTCString()
  }
  document.cookie = name + '=' + (value || '') + expires + '; path=/'
}

function getCookie(name) {
  const cookies = document.cookie.split('; ')
  for (const c of cookies) {
    const [cookieName, ...rest] = c.split('=')
    if (cookieName === name) {
      return rest.join('=')
    }
  }
  return null
}

function customUTCString() {
  return new Date().toUTCString()
}

module.exports = {
  getDeviceInfo,
  getBannerPlayerRegCookies,
  getXDirectBannerCookies,
  customSetCookie,
  getCookie,
  customUTCString
}
